<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex-18"></div>
      <div class="flex-64-5" style="margin-bottom:80px">
        <div class="flex-container row">
          <div class="flex-25"></div>
          <div class="flex-container row flex-align-center">
            <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true",
          "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
            <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true",
            "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
              NEW
              <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
            </div>
            <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true",
            "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
          </div>
          <div class="flex-25"></div>
        </div>
        <div class="bmw-lg-takata-content">
          <div class="flex-container" style="padding:26px 18px 16px 18px">
            <div class="bmw-lg-takata-title flex-60">Operating Fluids</div>
            <div class="flex"></div>
            <div class="flex-30">
              <form class="input-group" name="findDocs" style="width: 100%">
                <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Operating Fluids" name="techDoc"
                  [(ngModel)]="search4bulletins">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI ==='true', 'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true' ,'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}" class="btn btn-default"
                    type="submit">
                    <i class="glyphicon glyphicon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
          <div *ngIf='operatingFluidDocs?.length > 0'>
            <div *ngFor='let doc of operatingFluidDocs | searchFilter: "documentNumber,documentTitle": search4bulletins'>
              <a href='mount/operating_fluid/{{doc.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentNumber, doc?.documentTitle)'>
                <div class="bmw-lg-takata-doc flex-container flex-align-center" >
                  <div class="flex-8">{{doc?.documentNumber}}</div>
                  <div class="flex-40">{{doc?.documentTitle}}</div>
                  <div class="flex-8" style="text-align: right">
                    <i class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>
                      {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : doc.documentFileType === "zip" ? "file_download" : doc.documentFileType
                      === "xlsx" ? "insert_drive_file" : "" }}
                    </i>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>
<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex"></div>
      <div class="flex-70" style="margin-bottom:80px">
        <div class="flex-container row">
          <div class="flex-20"></div>
          <div class="flex-container row flex-align-center">
            <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
            <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true"}'
              class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
              NEW
              <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
            </div>
            <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}' class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
          </div>
          <div class="flex-20"></div>
        </div>
        <div class="bmw-lg-takata-content">
          <div class="flex-container" style="padding:26px 18px 16px 18px">
            <div class="bmw-lg-takata-title flex-60" style="font-size:30px">Operating Fluids</div>
            <div class="flex"></div>
            <div class="flex-31">
              <form class="input-group" name="findDocs" style="width: 100%">
                <input type="text" class="form-control" size=15 style="height:34px" placeholder="Find Operating Fluids" name="techDoc" [(ngModel)]="search4bulletins">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true','rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}" class="btn btn-default"
                    type="submit">
                    <i class="glyphicon glyphicon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div *ngFor='let doc of operatingFluidDocs | searchFilter: "documentNumber,documentTitle": search4bulletins'>
            <a href='mount/operating_fluid/{{doc.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentNumber, doc?.documentTitle)'>
              <div class="bmw-lg-takata-doc flex-container flex-align-center">
                <div class="flex-9">{{doc?.documentNumber}}</div>
                <div class="flex-40">{{doc?.documentTitle}}</div>
                <div class="flex-8" style="text-align: right">
                  <i class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>
                    {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : doc.documentFileType === "zip" ? "file_download" : doc.documentFileType
                    === "xlsx" ? "insert_drive_file" : "" }}
                  </i>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex-20"></div>
      <div class="flex-container row flex-align-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true")}' class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
      </div>
      <div class="flex-20"></div>
    </div>
    <div class="bmw-sm-takata-content">
      <div class="flex-container" style="padding:26px 18px 16px 18px">
        <div class="bmw-lg-takata-title flex-60" style="font-size:30px">Operating Fluids</div>
        <div class="flex"></div>
        <div class="flex-30">
          <form class="input-group" name="findDocs" style="width: 100%">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Operating Fluids" name="techDoc"
              [(ngModel)]="search4bulletins">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : ''|brandTypePipe, 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}" class="btn btn-default"
                type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngFor='let doc of operatingFluidDocs | searchFilter: "documentNumber,documentTitle": search4bulletins'>
        <a href='mount/operating_fluid/{{doc.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentNumber, doc?.documentTitle)'>
          <div class="bmw-lg-takata-doc flex-container flex-align-center">
            <div class="flex-9">{{doc?.documentNumber}}</div>
            <div class="flex-40">{{doc?.documentTitle}}</div>
            <div class="flex-8" style="text-align: right">
              <i class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>
                {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : doc.documentFileType === "zip" ? "file_download" : doc.documentFileType
                === "xlsx" ? "insert_drive_file" : "" }}
              </i>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="xs-visible" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex-container row flex-align-center">
        <div [ngClass]='{"bmw-active-link": isShowAll && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowAll && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowAll && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showAll()'>ALL</div>
        <div [ngClass]='{"bmw-active-link": isShowNew && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowNew && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowNew && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showNew()'>
          NEW
          <div class="badge" *ngIf="newDocsCount>0" [ngStyle]='{"background-color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>{{newDocsCount}}</div>
        </div>
        <div [ngClass]='{"bmw-active-link": isShowHistory && (APP_SETTINGS.isBMW === "true" || APP_SETTINGS.isMOTORRAD === "true"), "mini-active-link": isShowHistory && APP_SETTINGS.isMINI === "true", "rr-active-link" : isShowHistory && APP_SETTINGS.isRollsRoyce === "true"}'
          class="pointer" style="padding-bottom: 20px" (click)='showHistory()'>HISTORY</div>
      </div>
    </div>
    <div class="bmw-xs-takata-content">
      <div style="padding:26px 18px 16px 18px">
        <div class="bmw-lg-takata-title" style="font-size:24px; text-align: center;margin-bottom: 10px">Operating Fluids</div>
        <div>
          <form class="input-group" name="findDocs" style="width: 100%">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Operating Fluids" name="techDoc"
              [(ngModel)]="search4bulletins">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'rr-button-style' : APP_SETTINGS.isRollsRoyce === 'true','bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}" class="btn btn-default"
                type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngFor='let doc of operatingFluidDocs | searchFilter: "documentNumber,documentTitle": search4bulletins'>
        <a href='mount/operating_fluid/{{doc.documentFileName}}' target="_blank" (click)='saveToHistory(isShowHistory, doc?.id, doc?.documentNumber, doc?.documentTitle)'>
          <div class="bmw-lg-takata-doc flex-container flex-align-center">
            <div class="flex-20">{{doc?.documentNumber}}</div>
            <div class="flex-50">{{doc?.documentTitle}}</div>
            <div class="flex-8" style="text-align: right">
              <i class="material-icons" [ngStyle]='{"color": APP_SETTINGS.isMINI ? "#bf1a22": APP_SETTINGS.isRollsRoyce ? "#281432" : "#1c69d4"}'>
                {{ doc.documentFileType === "pdf" ? "picture_as_pdf" : doc.documentFileType === "zip" ? "file_download" : doc.documentFileType
                === "xlsx" ? "insert_drive_file" : "" }}
              </i>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>